// Module
var code = "<div class=\"teamManagement-avatar teamManagement-avatar-adduser\"></div>\n<div class=\"teamManagement-avatar-Name\">Add Team Member</div>\n";
// Exports
module.exports = code;